
import Vue from "vue";

export default Vue.extend({
  name: "Footer",

  data: () => ({
    socials: [
      { icon: "mdi-youtube" },
      { icon: "mdi-linkedin" },
      { icon: "mdi-twitter" },
      { icon: "mdi-facebook" },
    ],
    footlists1: [
      { title: "info@bayanatech.com.sa", iconn: "mdi-email-outline" },
      { title: "0503326610", iconn: "mdi-phone" },
    ],
    footlists2: [
      {
        text: "footer.services.link1",
      },
      {
        text: "footer.services.link2",
      },
      {
        text: "footer.services.link3",
      },
    ],
    footlists3: [
      {
        text: "footer.services.link4",
      },
      {
        text: "footer.services.link5",
      },
      {
        text: "footer.services.link6",
      },
    ],
    footlists4: [
      {
        text: "footer.solutions.link1",
      },
      {
        text: "footer.solutions.link2",
      },
      {
        text: "footer.solutions.link3",
      },
      {
        text: "footer.solutions.link4",
      },
    ],
  }),
});
